import { LogicNameFilter, NHIType } from "../../../../../utils/constants";
import { filterName, futureTimeOption, pastTimeOption } from "../utils";
import { areAllFiltersNotApplied, createEmptyFilters } from "./utils";

export const getNHISmartFiltersInfo = (
  appliedFilters,
  setAppliedFilters,
  filterAndOrLogics,
  setFilterAndOrLogics
) => {
  const oktaTokenApplied =
    appliedFilters[filterName.NHI_TYPE]?.[NHIType.OKTA_TOKEN] &&
    Object.entries(appliedFilters[filterName.NHI_TYPE])
      .filter(([type, _]) => type !== NHIType.OKTA_TOKEN)
      .every(([_, checked]) => !checked);

  const awsSecretApplied =
    appliedFilters[filterName.NHI_TYPE]?.[NHIType.AWS_SECRET] &&
    Object.entries(appliedFilters[filterName.NHI_TYPE])
      .filter(([type, _]) => type !== NHIType.AWS_SECRET)
      .every(([_, checked]) => !checked);

  const notUsed30DaysApplied =
    appliedFilters[filterName.NHI_LAST_USED]?.[pastTimeOption.LAST_30_DAYS] &&
    filterAndOrLogics[filterName.NHI_LAST_USED] === LogicNameFilter.TIME_BEFORE;

  const expirationIn7DaysApplied =
    appliedFilters[filterName.EXPIRATION_DATE]?.[futureTimeOption.IN_7_DAYS];

  return [
    {
      text: "Okta Token inactive for 30 days",
      applied:
        oktaTokenApplied &&
        notUsed30DaysApplied &&
        areAllFiltersNotApplied({
          appliedFilters: appliedFilters,
          excludedFilterNames: [filterName.NHI_TYPE, filterName.NHI_LAST_USED],
        }),
      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);
        updatedFilters[filterName.NHI_TYPE][NHIType.OKTA_TOKEN] = true;

        updatedFilters[filterName.NHI_LAST_USED][
          pastTimeOption.LAST_30_DAYS
        ] = true;

        setAppliedFilters(updatedFilters);
        setFilterAndOrLogics((prev) => ({
          ...prev,
          [filterName.NHI_LAST_USED]: LogicNameFilter.TIME_BEFORE,
        }));
      },
    },
    // NOTE - We currently don't collect the last used date for AWS Secrets
    // {
    //   text: "High Risk AWS Secret not used for 30 days",
    //   applied:
    //     awsSecretApplied &&
    //     notUsed30DaysApplied &&
    //     areHighRisksApplied(appliedFilters) &&
    //     areAllFiltersNotApplied({
    //       appliedFilters: appliedFilters,
    //       excludedFilterNames: [
    //         filterName.RISK,
    //         filterName.NHI_TYPE,
    //         filterName.NHI_LAST_USED,
    //       ],
    //     }),
    //   onClick: () => {
    //     const updatedFilters = createEmptyFilters(appliedFilters);

    //     highRisksOptions.forEach((risk) => {
    //       updatedFilters[filterName.RISK][risk] = true;
    //     });

    //     updatedFilters[filterName.NHI_TYPE][NHIType.AWS_SECRET] = true;

    //     updatedFilters[filterName.NHI_LAST_USED][
    //       pastTimeOption.LAST_30_DAYS
    //     ] = true;

    //     setAppliedFilters(updatedFilters);
    //     setFilterAndOrLogics((prev) => ({
    //       ...prev,
    //       [filterName.NHI_LAST_USED]: LogicNameFilter.TIME_BEFORE,
    //     }));
    //   },
    // },
    {
      text: "Identity to expire in 7 days",
      applied:
        expirationIn7DaysApplied &&
        areAllFiltersNotApplied({
          appliedFilters: appliedFilters,
          excludedFilterNames: [filterName.EXPIRATION_DATE],
        }),
      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);

        updatedFilters[filterName.EXPIRATION_DATE][
          futureTimeOption.IN_7_DAYS
        ] = true;

        setAppliedFilters(updatedFilters);
      },
    },
  ];
};
